export default __webpack_public_path__ + "static/media/skyniche-logo.2cf80bee.png";